import { render, staticRenderFns } from "./BeyondAcademics.vue?vue&type=template&id=491c8b26"
import script from "./BeyondAcademics.vue?vue&type=script&lang=js"
export * from "./BeyondAcademics.vue?vue&type=script&lang=js"
import style0 from "./BeyondAcademics.vue?vue&type=style&index=0&id=491c8b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports